exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bg-primary-pink{background-color:#f8264d!important}.bg-primary-violet{background-color:#7a00ff!important}.timeline{padding-left:100px;position:relative}.timeline:before{content:\"\";position:absolute;top:30px;left:30px;height:100%;width:4px;background:#333}.event{margin:0 0 30px;overflow:hidden}.event header{margin-bottom:0!important}.event .body{padding:30px 30px 150px;position:relative}.event .body .title{margin-bottom:30px}.event .body .title h1{font-size:3rem;margin:0;color:#333}.event .body .icon{position:absolute;left:-99px;top:20px;border-radius:50%;height:60px;width:60px;line-height:60px;background-color:#7a00ff;color:#fff;text-align:center;font-size:4rem}.event .body .media{position:absolute;width:100%;height:120px;left:0;bottom:0;transition:height .5s}.event .body .media:hover{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/styles/Timeline.less
// module id = 316
// module chunks = 0